import { KNM_VERIFIED_PERSON } from 'CorePackage/MainModule/routes/routes';

export const MANUAL_ADDRESS_BLOCK_ID = 'manualAddress';
export const REGION_BLOCK_ID = 'region';
export const ACTS_BLOCK_ID = 'actsBlock';
export const getActBlockId = (id: string) => `acts[${id}]`;
export const getActOrganizationTemplateBlockId = (actId: string) => `acts[${actId}].organizationTemplate`;
export const getActOgrnLabelBlockId = (actId: string) => `acts[${actId}].ogrnLabelBlock`;
export const getActInnLabelBlockId = (actId: string) => `acts[${actId}].innLabelBlock`;
export const getActOrganizationNameBlockId = (actId: string) => `acts[${actId}].organizationNameBlock`;
export const getActAddressBlockId = (actId: string) => `acts[${actId}].addressBlock`;
export const getActKnoInspectorsBlockId = (actId: string) => `${actId}.knoInspectors`;
export const getActKnoFioSignerBlockId = (actId: string) => `${actId}.fioSigner`;
export const getActKnoTitleSignerBlockId = (actId: string) => `${actId}.titleSigner`;
export const getActKnoInspectorBlockId = (actId: string, id: string) => `${actId}.knoInspectors[${id}]`;
export const getActKnoExpertsBlockId = (actId: string) => `${actId}.involvedExperts`;
export const getActKnoExpertBlockId = (actId: string, id: string) => `${actId}.involvedExperts[${id}]`;
export const getActKnoWitnessesBlockId = (actId: string) => `${actId}.involvedWitnesses`;
export const getActKnoWitnessBlockId = (actId: string, id: string) => `${actId}.involvedWitnesses[${id}]`;
export const getActFioReaderBlockId = (actId: string) => `${actId}.fioReader`;
export const getActTitleReaderBlockId = (actId: string) => `${actId}.titleReader`;
export const getActRefuserFioBlockId = (actId: string) => `${actId}.refuserFio`;
export const getActRefuserTitleBlockId = (actId: string) => `${actId}.refuserTitle`;
export const getActTypeActBlockId = (actId: string) => `${actId}.typeAct`;
export const getActCanceledReasonBlockId = (actId: string) => `${actId}.canceledReason`;
export const getActCanceledReasonDescriptionBlockId = (actId: string) => `${actId}.canceledReasonDescription`;
export const getActDocumentAttachmentsBlockId = (actId: string) => `${actId}.document.attachments`;
export const getActFamiliarizationNotificationsBlock = (actId: string) => `${actId}.familiarizationNotifications`;
export const getActFamiliarizationNotificationsBlockId = (actId: string, id: string) =>
  `${actId}.familiarizationNotifications[${id}]`;
export const getActRemarksBlockId = (actId: string, id: string) => `${actId}.remarks[${id}]`;
export const getActEventsBlock = (actId: string) => `${actId}.events`;
export const getActEventsBlockId = (actId: string) => `acts[${actId}].events`;
export const getActAcquaintanceTypeBlockId = (actId: string) => `${actId}.acquaintanceType`;
export const getActAcquaintanceLackTypeBlockId = (actId: string) => `${actId}.acquaintanceLackType`;
export const getActEventBlockId = (actId: string, eventId: string) => `${actId}.events[${eventId}]`;
export const getActEventExpertsBlockId = (actEventId: string) => `${actEventId}.experts`;
export const getActEventExpertBlockId = (actEventId: string, expertId: string) => `${actEventId}.experts[${expertId}]`;
export const getActEventInspectorsBlockId = (eventId: string, inspectorId: string) =>
  `${eventId}.inspectors[${inspectorId}]`;
export const getActEventProtocolBlockId = (eventId: string) => `${eventId}.protocol`;
export const getActEventAppendicesToTheProtocolOfActionBlockId = (eventId: string, id: string) =>
  `${eventId}.protocol.appendicesToTheProtocolOfAction[${id}]`;
export const getActEventStudiedDocumentsBlockId = (eventId: string, id: string) =>
  `${eventId}.protocol.studiedDocuments[${id}]`;
export const getActNumberBlockId = (actId: string) => `acts[${actId}].numberAct`;
export const getActCreationActDateTimeBlockId = (actId: string) => `acts[${actId}].creationActDateTime`;
export const getActHoldingDateTimeBlockId = (actId: string) => `acts[${actId}].holdingDateTime`;
export const getActDurationDays = (actId: string) => `acts[${actId}].durationDays`;
export const getActDurationHours = (actId: string) => `acts[${actId}].durationHours`;
export const APPROVE_DOCS_BLOCK_ID = 'approveDocsBlock';
export const DOC_TARGET_BLOCK_ID = 'docTargetBlock';
export const TAKEN_MEASURES_BLOCK_ID = 'takenMeasuresBlock';
export const LINKS_BLOCK_ID = 'linksBlock';
export const APPROVE_REQUIRED_BLOCK_ID = 'approveRequiredBlock';
export const DATA_CONTENT_BLOCK_ID = 'dataContentBlock';
export const APPROVED_BLOCK_ID = 'approvedBlock';
export const REJECTED_REASON_TYPE_BLOCK_ID = 'rejectReasonTypeBlock';
export const COLLABORATING_ORGANIZATIONS_BLOCK_ID = 'collaboratingOrganizationsBlock';
export const APPROVED_ON_PAPER_DOCUMENTS_BLOCK_ID = 'approvedOnPaperDocumentsBlock';
export const DURATION_DAYS_BLOCK_ID = 'durationDaysBlock';
export const DURATION_HOURS_BLOCK_ID = 'durationHoursBlock';
export const DIRECT_DURATION_DAYS_BLOCK_ID = 'directDurationDaysBlock';
export const EVENTS_BLOCK_ID = 'eventsBlock';
export const KIND_CONTROL_BLOCK_ID = 'kindControlBlock';
export const KIND_KNM_BLOCK_ID = 'kindKnmBlock';
export const KNO_ORGANIZATION_BLOCK_ID = 'knoOrganizationBlock';
export const KNO_APPLY_CHANGED_BLOCK_ID = 'applyChangedBlock';
export const ACT_BLOCK_ID = 'act';

export const getReschedulingBlockId = (id: string) => `rescheduling[${id}]`;

export const ABROGATION_REASON_ID_BLOCK_ID = 'abrogationReasonIdBlock';
export const ABROGATION_LINK_BLOCK_ID = 'abrogationLinkBlock';
export const PLACE_DECISION_BLOCK_ID = 'placeDecisionBlock';
export const FIO_SIGNER_BLOCK_ID = 'fioSignerBlock';
export const TITLE_SIGNER_BLOCK_ID = 'titleSignerBock';
export const SINGERS = 'signers';
export const getSignerFio = (id: string) => `signers[${id}].fioSigner`;
export const getSignerTitle = (id: string) => `signers[${id}].titleSigner`;
export const OBJECTS_BLOCK_ID = 'objectsBlock';
export const OKVEDS_BLOCK_ID = 'okvedsBlock';
export const ORGANIZATION_DOCUMENTS_BLOCK_ID = 'organizationDocumentsBlock';
export const getOrganizationDocumentBlockId = (id: string) => `organizationDocuments[${id}]`;
export const ORGANIZATIONS_BLOCK_ID = KNM_VERIFIED_PERSON;
export const EVENT_INSPECTORS_BLOCK_ID = 'eventInspectorsBlock';
export const getOrganizationBlockId = (id: string) => `organizations[${id}]`;
export const getOrganizationOgrnLabelBlockId = (organizationId: string) => `${organizationId}.ogrnLabelBlock`;
export const getOrganizationInnLabelBlockId = (organizationId: string) => `${organizationId}.innLabelBlock`;
export const getOrganizationKppLabelBlockId = (organizationId: string) => `${organizationId}.kppLabelBlock`;
export const getOrganizationRafpNzaLabelBlockId = (organizationId: string) => `${organizationId}.rafpNzaLabelBlock`;
export const getOrganizationNameBlockId = (organizationId: string) => `${organizationId}.organizationNameBlock`;
export const getPositionBlockId = (organizationId: string) => `${organizationId}.positionBlock`;
export const getOrganizationOkvedsBlockId = (organizationId: string) => `${organizationId}.okvedsBlock`;
export const getOrganizationOkvedBlockId = (organizationId: string, id: string) => `${organizationId}.okveds[${id}]`;
export const getOrganizationMspBlockId = (id: string) => `organizations[${id}].mspCode`;
export const getOrganizationSonkoBlockId = (id: string) => `organizations[${id}].isSonko`;
export const getOrganizationNkoBlockId = (id: string) => `organizations[${id}].isNko`;
export const PLAN_ID_BLOCK_ID = 'planIdBlock';
export const PROSECUTOR_ORGANIZATION_BLOCK_ID = 'prosecutorOrganizationBlock';
export const APPROVE_NOTE_BLOCK_ID = 'approveNoteBlock';
export const APPROVE_NOTE_APPEAL_BLOCK_ID = 'approveNoteAppealBlock';
export const START_DATE_BLOCK_ID = 'startDateBlock';
export const START_TIME_BLOCK_ID = 'startTimeBlock';
export const STOP_DATE_BLOCK_ID = 'stopDateBlock';
export const STOP_TIME_BLOCK_ID = 'stopTimeBlock';
export const TYPE_BLOCK_ID = 'typeBlock';
export const OLD_KNM_NUMBER = 'oldKnmNumber';
export const OLD_PLAN_NUMBER = 'oldKnmNumber';
export const INSPECTORS_BLOCK_ID = 'inspectorsBlock';
export const REASONS_BLOCK_ID = 'reasonsBlock';
export const EXPERTS_BLOCK_ID = 'expertsBlock';
export const REASON_DOCUMENTS_BLOCK_ID = 'reasonDocumentsBlock';
export const INTERACTION_CATEGORY_ID = 'interactionCategory';
export const REMOTE_NOTE_ID = 'remoteNote';
export const PLACES_BLOCK_ID = 'placesBlock';
export const CHECLISTS_BLOCK_ID = 'checklistsBlock';
export const getChecklistQuestionsBlockId = (id: string) => `checklists[${id}].questions`;
export const REQUIREMENTS_BLOCK_ID = 'requirementsBlock';
export const getRequirementBlockId = (id: string) => `requirements[${id}]`;
export const RESULT_DECISIONS_BLOCK_ID = 'resultDecisionsBlock';
export const AGREEMENTS_BLOCK_ID = 'agreementsBlock';
export const getAgreementsBlockId = (id: string) => `agreements[${id}]`;
export const AGREEMENTS_APPROVE_NOTE_BLOCK_ID = 'agreementsApproveNoteBlock';
export const JUDGMENTS_BLOCK_ID = 'judgmentsBlock';
export const getResultDecisionBlockId = (id: string) => `resultDecisions[${id}]`;
export const getResultDecisionActId = (id: string) => `resultDecisions[${id}].act`;
export const getResultDecisionOrganizationTemplateBlockId = (resultDecisionId: string) =>
  `resultDecisions[${resultDecisionId}].organizationTemplateBlock`;
export const getResultDecisionOgrnLabelBlockId = (resultDecisionId: string) =>
  `resultDecisions[${resultDecisionId}].ogrnLabelBlock`;
export const getResultDecisionInnLabelBlockId = (resultDecisionId: string) =>
  `resultDecisions[${resultDecisionId}].innLabelBlock`;
export const getResultDecisionOrganizationNameBlockId = (resultDecisionId: string) =>
  `resultDecisions[${resultDecisionId}].organizationNameBlock`;
export const getResultDecisionAddressBlockId = (resultDecisionId: string) =>
  `resultDecisions[${resultDecisionId}].addressBlock`;
export const getResultDecisionInspectorsBlockId = (resultDecisionId: string) =>
  `resultDecisions[${resultDecisionId}].inspectors`;
export const getResultDecisionInspectorBlockId = (resultDecisionId: string, id: string) =>
  `${resultDecisionId}.inspectors[${id}]`;
export const getResultDecisionNoteLawsuitsBlockId = (resultDecisionId: string) =>
  `resultDecisions[${resultDecisionId}].noteLawsuits`;
export const getResultDecisionKindDecisionBlockId = (resultDecisionId: string) =>
  `resultDecisions[${resultDecisionId}].kindDecision`;
export const getResultDecisionNoteLawsuitBlockId = (resultDecisionId: string, id: string) =>
  `resultDecisions[${resultDecisionId}].noteLawsuits[${id}]`;
export const getResultDecisionNoteLawsuitBlockIdForField = (resultDecisionId: string, id: string, field: string) =>
  `resultDecisions[${resultDecisionId}.noteLawsuits[${id}].${field}]`;
export const getResultDecisionResponsibleEntitiesBlockId = (resultDecisionId: string) => `${resultDecisionId}`;
export const getResultDecisionResponsibleEntities = (resultDecisionId: string) =>
  `resultDecisions[${resultDecisionId}].responsibleEntities`;
export const getResultDecisionResponsibleEntityBlockId = (resultDecisionId: string, id: string) =>
  `resultDecisions[${resultDecisionId}].responsibleEntities[${id}]`;
export const getResultDecisionResponsibleEntityStructuresNPABlockId = (resultDecisionId: string) =>
  `${resultDecisionId}`;
export const getResultDecisionResponsibleEntityResponsibilityTypeBlockId = (
  resultDecisionResponsibleEntityId: string,
) => `${resultDecisionResponsibleEntityId}`;
export const getResultDecisionNumberDecisionBlockId = (resultDecisionId: string) =>
  `resultDecisions[${resultDecisionId}].numberDecision`;
export const getResultDecisionDateDecisionBlockId = (resultDecisionId: string) =>
  `resultDecisions[${resultDecisionId}].dateDecision`;
export const getResultDecisionIsProsecutionBlockId = (resultDecisionId: string) =>
  `resultDecisions[${resultDecisionId}].isProsecution`;
export const getApproveDocBlockId = (id: string) => `approveDocs[${id}]`;
export const getDocTargetBlockId = (id: string) => `docTarget[${id}]`;
export const getCollaboratingOrganizationBlockId = (id: string) => `collaboratingOrganizations[${id}]`;
export const VIDEO_CALL_INFO_WRAPPER_BLOCK_ID = `videoCallInfoWrapper`;
export const getVideoCallInfoBlockId = (id: string) => `videoCallInfo[${id}]`;
export const getDocumentBlockId = (id: string) => `documents[${id}]`;
export const getEventBlockId = (id: string) => `events[${id}]`;
export const getEventTypeBlockId = (id: string) => `events[${id}].type`;
export const getEventInteractionCategoryBlockId = (id: string) => `events[${id}].interactionCategory`;
export const getEventStartDateBlockId = (id: string) => `events[${id}].startDate`;
export const getEventStopDateBlockId = (id: string) => `events[${id}].stopDate`;
export const getExpertBlockId = (id: string) => `experts[${id}]`;
export const getInspectorBlockId = (id: string) => `inspectors[${id}]`;
export const getPlaceBlockId = (id: string) => `places[${id}]`;
export const getReasonDocumentBlockId = (id: string) => `reasonDocuments[${id}]`;
export const getReasonDocumentAttachmentsBlockId = (id: string) => `reasonDocuments[${id}].attachments`;
export const getReasonDocumentViolationEvidencesBlockId = (id: string) => `reasonDocuments[${id}].violationEvidences`;
export const getReasonBlockId = (id: string) => `reasonsErknm[${id}]`;
export const getReasonRiskIndicatorsBlockId = (id: string) => `reasonsErknm[${id}].riskIndicators`;
export const getReasonViolationEvidencesBlockId = (id: string) => `reasonsErknm[${id}].violationEvidences`;
export const getReasonRiskIndicatorBlockId = (reasonId: string, indicatorRiskId: string) =>
  `reasonsErknm[${reasonId}].riskIndicators[${indicatorRiskId}]`;
export const getSuspensionEventBlockId = (id: string) => `suspensionEvents[${id}]`;
export const getJudgmentBlockId = (id: string) => `judgments[${id}]`;
export const getJudgmentDateBlockId = (id: string) => `judgments[${id}].dateJudgment`;
export const getJudgmentNumberBlockId = (id: string) => `judgments[${id}].numberJudgment`;
export const getJudgmentAttachmentBlockId = (id: string) => `judgments[${id}].attachment`;
export const getJudgmentKindBlockId = (id: string) => `judgments[${id}].kindJudgment`;
export const getJudgmentRfRegionBlockId = (id: string) => `judgments[${id}].rfRegionCode`;
export const getJudgmentCourtBlockId = (id: string) => `judgments[${id}].court`;
export const getJudgmentCourtLevelBlockId = (id: string) => `judgments[${id}].courtLevelCode`;
export const getJudgmentActionBlockId = (id: string) => `judgments[${id}].judgmentAction`;
export const getJudgmentSubjectDataBlockId = (id: string) => `${id}.judgmentSubjectData`;
export const getJudgmentSubjectDataItemBlockId = (judgmentId: string, judgmentSubjectDataId: string) =>
  `${judgmentId}.judgmentSubjectData[${judgmentSubjectDataId}]`;
export const getJudgmentAgainstOfficialPersonBlockId = (
  judgmentSubjectDataId: string,
  judgmentAgainstOfficialPersonId: string,
) => `${judgmentSubjectDataId}.judgmentAgainstOfficialPerson[${judgmentAgainstOfficialPersonId}]`;
export const getJudgmentCancellationInfoBlockId = (judgmentSubjectDataId: string) =>
  `${judgmentSubjectDataId}.cancellationActsAndDecisions`;
export const getJudgmentActCancellationInfoItemInfoBlockId = (
  judgmentSubjectDataId: string,
  cancellationItemId: string,
) => `${judgmentSubjectDataId}.cancellationActsAndDecisions[${cancellationItemId}].cancellationInformation`;
export const getJudgmentActCancellationInfoItemExplanationBlockId = (
  judgmentSubjectDataId: string,
  cancellationItemId: string,
) => `${judgmentSubjectDataId}.cancellationActsAndDecisions[${cancellationItemId}].explanation`;
export const getJudgmentCanceledJudgmentsBlockId = (id: string) => `${id}.canceledJudgments`;
export const getJudgmentCanceledJudgmentItemBlockId = (judgmentId: string, canceledJudgmentId: string) =>
  `${judgmentId}.canceledJudgments[${canceledJudgmentId}]`;

export const getComplexDataBlockId = (id: string) => `${id}`;

export const getApproveRemarkBlockId = (id: string) => `approveRemarks[${id}]`;
export const getUavTechnologiesNameBlockId = (id: string) => `uavTechnologies[${id}].name`;
export const getUavTechnologiesTypeBlockId = (id: string) => `uavTechnologies[${id}].type`;

export const TEXT_REACT_QUILL_EDITOR_BLOCK_ID = `reasonsErknm[0].textReactQuillEditor`;
export const REASON_PASSPORT_LINKS_BLOCK_ID = 'reasonsErknm[0].passportLinks';
export const KNM_APPROVE_CHANGE_KNM = 'knm-approve-change-knm';

export const getNormalizedEventKnmBlockId = (id: string): string => {
  let result = id;

  if (result.startsWith('eventsErknm')) {
    result = result.replace(/^eventsErknm/, 'events');
  }

  const submittedDocsIndex = result.indexOf('.submittedDocuments');

  if (submittedDocsIndex !== -1) {
    result = result.substring(0, submittedDocsIndex);
  }

  return result;
};
